import axios from "../../../services/axios-config.js";

export async function registerCommissionedAgent({ data }) {
  const res = await axios.post("/commissioned/register", { data });
  return res?.data;
}
